
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingDonateButton from "@/components/ui/FloatingDonateButton";
import FloatingShareButton from "@/components/ui/FloatingShareButton";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* 導覽列 */}
      <Navbar />
      
      {/* 主要內容區域 */}
      <main className="flex-grow">{children}</main>
      
      {/* 頁腳 */}
      <Footer />
      
      {/* 浮動按鈕群組 */}
      <FloatingShareButton />
      <FloatingDonateButton />
    </div>
  );
};

export default MainLayout;
